module.exports = __webpack_public_path__ + "static/img/partner4.f7f94b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner4.png
// module id = esan
// module chunks = 0